<template>
    <form class="announcement-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['title']}">
            <label for="title" class="col-sm-2 control-label">Título</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.title">
                <div class="help-block" v-for="e in errors['title']">{{e}}</div>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['text']}">
            <label for="text" class="col-sm-2 control-label">Texto</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="text" v-model="data.text" rows="2"></textarea>
                <div class="help-block" v-for="e in errors['text']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['url']}">
            <label for="url" class="col-sm-2 control-label">URL destino</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="url" v-model="data.url">
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['tooltip']}">
            <label for="tooltip" class="col-sm-2 control-label">Texto ayuda</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="tooltip" v-model="data.tooltip">
                <div class="help-block" v-for="e in errors['tooltip']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['icon']}">
            <label for="icon" class="col-sm-2 control-label">Ícono</label>
            <div class="col-sm-8">
                <!--<input type="text" class="form-control" id="tooltip" v-model="data.icon">-->
                <icon-select id="icon" v-model="data.icon" :icons="this.icons"></icon-select>
                <div class="help-block" v-for="e in errors['icon']">{{e}}</div>
            </div>
            <div class="col-sm-2">                
                <a class="btn btn-default" target="_blank" href="https://material.io/tools/icons/?style=baseline" title="Acceder a biblioteca de íconos">Ver íconos</a>
            </div>
        </div>        
        <div class="form-group" :class="{'has-error': errors['active']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.active" :value="true" /> Si</label></br>
                    <label><input type="radio" v-model="data.active" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['active']">{{e}}</div>
            </div>
        </div>
        <div v-if="data.active && must_delete" class="form-group" :class="{'has-error': errors['deactivate']}">
            <div class="col-sm-offset-2 col-sm-10">
                <p>Se alcanzó el límite de 4 tarjetas activas. Desactive alguna de las siguientes para continuar.</p>
                <el-select filterable :loading="loading" v-model="data.deactivate">
                    <el-option v-for="c in tarjetas" :label="c.title + ' (id: '+c.id+')'" :value="c.id" :key="c.id"></el-option>
                </el-select>
                <div class="help-block" v-for="e in errors['deactivate']">{{e}}</div>
            </div>
        </div>
        <div v-if="data.active" class="form-group" :class="{'has-error': errors['order']}">
            <label for="order" class="col-sm-2 control-label">Posición</label>
            <div class="col-sm-10">
                <el-select filterable :loading="loading" v-model="data.order">
                    <el-option v-for="c in positions" :label="c.label + '°'" :value="c.value" :key="c.value"></el-option>
                </el-select>
                <!--<input type="number" step="1" class="form-control" id="order" v-model.number="data.order">-->
                <div class="help-block" v-for="e in errors['order']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-offset-2 col-sm-10">
                <div class="help-cards">
                    <div class="row">                        
                        <div class="col-sm-12">
                            <a :href="data.url" target="_blank" class="help-card" :title="data.tooltip">
                                <div class="media">
                                    <div class="media-left">
                                        <i class="material-icons">{{data.icon}}</i>
                                    </div>
                                    <div class="media-body">
                                        <div class="media-heading">{{data.title}}</div>
                                        <p>{{data.text}}</p>
                                    </div>
                                </div>
                            </a>
                        </div>        
                    </div>                    
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/centro-ayuda">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-date-picker{
        display: block;
    }
    .el-select{
        display: block;
    }
    .help-cards .help-card .media-left {
        color: #ed3232;
    }
    .help-cards .help-card .media-body .media-heading {
        color: #09132e;
        font-size: 18px;
        font-family: Roboto Slab,sans-serif;
        line-height: 1;
    }
    .help-cards .help-card .media-body p {
        font-size: 14px;
        color: #757575;
        font-weight: 400;
        line-height: 1.3;
    }
    .media-body, .media-left, .media-right {
        display: table-cell;
        vertical-align: top;
    }
    .media-left, .media > .pull-left {
        padding-right: 10px;
    }
    .help-cards .help-card {
        height: 100px;
        width: 242.5px;
        padding: 20px 15px;
        display: inline-block;
        border: 1px solid #d7d6d7;
        border-radius: 4px;
        transition: .2s ease;
        margin: 0 0 20px;
    }
    a:focus, a:hover {
        color: #23527c;
        text-decoration: underline;
    }
    a:active, a:hover {
        outline: 0;
    }
    .help-cards .help-card:hover {
        box-shadow: 0 0 10px 0 rgba(0,0,0,.3);
        text-decoration: none;
    }
</style>
<script>
    import Vue from 'vue';
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';
    import IconSelect from './IconSelect.vue';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                title: '',
                text: '',
                tooltip: '',
                url: '',
                icon: '',
                order: null,
                active: null,
                created_at: null,
                updated_at: null,
                deactivate: null,
                should_deactivate: null
            };
            
            return{
                data: _.assign(data, this.help_card),
                tarjetas: _.cloneDeep(this.cards),
                disabled: false,
                must_delete: false,
                errors: {},
                positions: [{
                    value: 1,
                    label: '1'
                    }, {
                    value: 2,
                    label: '2'
                    }, {
                    value: 3,
                    label: '3'
                    }, {
                    value: 4,
                    label: '4'
                    }
                ]
            }
        },
        props: ['help_card','edit','cards','icons'],
        methods:{
            preview(){
                alert('preview');
            },
            test(){
                alert('hola');
            },   
            submit: function(){
                var self = this;
                self.data.should_deactivate = self.must_delete;

                axios({
                    url: self.edit ? 'backend/centro-ayuda/'+self.data.id : 'backend/centro-ayuda',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            },
        },
        components:{
            ElSelect,
            ElOption,
            IconSelect
        },
        mounted() {
            var self = this;

            var cantidad = _.size(self.tarjetas);
            if (cantidad >= 4){
                self.must_delete = true;
                _.forEach(self.tarjetas, function(value,key) {
                    if (value.title === self.help_card.title){
                        self.must_delete = false;
                    }
                })
            }                
        }
    }
</script>